import { SampleType } from "./GovPoolModel/CollectionTypeResponse"
import { ObservableFromFetch } from "../ObservableFromFetch"

export default function GovGetCollectionTypes() {
  return ObservableFromFetch<SampleType[]>("GovPool/GetCollectionTypes")
}
